module.exports = function() {
  return new Worker(__webpack_public_path__ + "20700b660a906d1940f4.worker.js");
};